import React from 'react';
import { ReplacementType } from '../../../lib/REST/types';
import { BlocksFunctionsType } from '../types';
import { SelectorPortal } from '../../SelectorPortal';
import { parseLog } from '../../Logger/utils';
import { getCreatePortalKey } from '../../MainApp/utils';

type OnItemRenderedType =
	| (() => () => void)
	| ((
			replacementId: string,
			onRenderedCb?: (() => void) | undefined
	  ) => () => void);

type BlockSelectorsReplacerType = {
	replacements: ReplacementType[] | null;
	campaignId: string;
	contentId: string;
	correlationId?: string | null;
	onReplacementsRendered: OnItemRenderedType;
} & BlocksFunctionsType;

export function BlockSelectorsReplacer({
	replacements,
	campaignId,
	correlationId,
	contentId,
	onReplacementsRendered,
	onAppear,
	onRendered,
	onClickLink,
}: BlockSelectorsReplacerType) {
	if (!replacements || !replacements.length) {
		return null;
	}

	return (
		<>
			{replacements.map((replacement) => {
				const {
					component,
					selector,
					replacementId = '',
					impressionId,
				} = replacement;
				const blockInfo = {
					component,
					selector,
					replacementId,
					impressionId,
					isDefaultContent: contentId === 'default',
				};

				const onRenderedCb = () =>
					onRendered({
						campaignId,
						contentId,
						replacementId,
						impressionId,
						correlationId,
						selector,
					});

				return (
					<SelectorPortal
						{...blockInfo}
						getComment={(prevHTML: string) =>
							parseLog({
								campaignId,
								correlationId,
								contentId,
								replacementId,
								selector,
								prevHTML,
							})
						}
						onAppear={() =>
							onAppear({
								campaignId,
								contentId,
								replacementId,
								impressionId,
								correlationId,
								selector,
							})
						}
						key={getCreatePortalKey({
							contentId,
							campaignId,
							replacementId,
							selector,
						})}
						onRendered={onReplacementsRendered(replacementId, onRenderedCb)}
						onLinkClick={(url: string) =>
							onClickLink({
								campaignId,
								correlationId,
								replacementId,
								impressionId,
								contentId,
								url,
								selector,
							})
						}
					/>
				);
			})}
		</>
	);
}
